import React, { useState } from 'react'
import Select from 'react-select'
import { aramayaUyar } from './secimArama'
import { Helpers } from '../helpers/Helpers';
import { toast } from "react-hot-toast";
import { useDispatch } from 'react-redux';
import { storeActivityIndicator } from '../redux/reducers/authSlice';
import { AddConstantResponse } from '../models/response/constant/AddConstantResponse';
import { ConstantService } from '../services/ConstantService';

export interface CustomMultiSelectModel {
    label: string;
    value: string;
    additionalValue1?: string | undefined
}

interface CustomSingleSelectOnSubmitModel {
    code: string
    parentConstantId?: string
}

interface Insertable {
    onSubmit?: CustomSingleSelectOnSubmitModel
    onClick?: () => void
}

interface Props {
    onChange: (_list: CustomMultiSelectModel[]) => void
    selectedValues: CustomMultiSelectModel[]
    insertable: Insertable | undefined
    disabled: boolean
    onMenuOpen: (() => Promise<any>) | undefined
    labelName: 'name' | 'value' | 'nameSurname' | 'plate' | 'additionalValue1' | 'gTip1' | 'addressTypeName' | 'label' | 'roleName' | 'vehicleName'
    label2Name?: 'gTipDesc'
    valueName: 'deviceId' | 'constantId' | 'companyId' | 'driverId' | 'vehicleId' | 'gTipId' | 'serviceId' | 'addressTypeId' | 'value' | 'roleId' | 'productId'
    additionalValue1Name: string | undefined
    innerPropName: string | undefined
    labelText: string | undefined
    isLabelRequired: boolean
    /** Liste sayfanın üst katmanında açılır (altındaki tablo başlığının arkasında kalmasın). */
    menuPortal?: boolean
}

const CustomMultiSelect = ({
    onChange,
    selectedValues,
    insertable,
    disabled,
    additionalValue1Name,
    innerPropName,
    labelName,
    onMenuOpen,
    valueName,
    label2Name,
    labelText,
    isLabelRequired,
    menuPortal,
}: Props) => {
    const dispatch = useDispatch();
    const [isInserting, setIsInserting] = useState(false);
    const [insertValue, setInsertValue] = useState('');
    const [items, setItems] = useState<CustomMultiSelectModel[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const addConstant = async (_code: string, _parentConstantId: string | undefined = undefined) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: AddConstantResponse = await ConstantService.addConstant(undefined, _code, insertValue, _parentConstantId);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message);

            onChange([...selectedValues, { label: response.data.value, value: response.data.constantId }]);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const submitHandler = () => {
        if (insertable) {
            if (Helpers.isEmpty(insertValue)) {
                toast.error('Lütfen boş alan bırakmayınız!')
                return;
            }

            if (insertable && insertable.onSubmit)
                addConstant(insertable.onSubmit.code, insertable.onSubmit.parentConstantId);

            setIsInserting(false);
            setInsertValue('');
        }
    }

    const handleOnMenuOpen = async () => {
        try {
            if (onMenuOpen) {
                // toast.error(items.length.toString())

                setIsLoading(true);

                var response: any = await onMenuOpen();

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                if (innerPropName) {
                    response = {
                        data: response.data[innerPropName]
                    }
                }

                var tempItems = response.data.map(function (x: any) {
                    return { label: x[labelName].toString() + (label2Name ? (' - ' + x[label2Name]) : ''), value: x[valueName].toString(), additionalValue1: (additionalValue1Name ? x[additionalValue1Name] : undefined) }
                })

                setItems(tempItems);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <React.Fragment>
            {
                labelText && (
                    <label className={"form-label " + (isLabelRequired ? 'required' : '')}>{labelText}</label>
                )
            }

            <div className='d-flex'>
                <div style={{ maxWidth: '100%' }} className='d-flex flex-grow-1'>
                    {
                        !isInserting ?
                            (
                                <Select
                                    isDisabled={disabled}
                                    className='react-select-styled react-select-solid'
                                    classNamePrefix='react-select'
                                    options={items}
                                    filterOption={(secenek, aranan) => aramayaUyar(secenek.label, aranan)}
                                    placeholder='Seçiniz'
                                    isMulti
                                    onChange={(e) => onChange(e.map(function (x) {
                                        return { label: x.label, value: x.value, additionalValue1: x.additionalValue1 }
                                    }))}
                                    value={selectedValues}
                                    closeMenuOnSelect={false}
                                    noOptionsMessage={() => 'Kayıt bulunamadı.'}
                                    menuPlacement='auto'
                                    isLoading={isLoading}
                                    onMenuOpen={handleOnMenuOpen}
                                    onMenuClose={() => setItems([])}
                                    menuPortalTarget={menuPortal ? document.body : undefined}
                                    styles={menuPortal ? { menuPortal: (base) => ({ ...base, zIndex: 9999 }) } : undefined}
                                    isClearable
                                />
                            )
                            :
                            (
                                <React.Fragment>
                                    <input placeholder='Giriniz...' value={insertValue} onChange={(e) => setInsertValue(e.target.value)} type="email" className="form-control form-control-solid" />
                                </React.Fragment>
                            )
                    }
                </div>

                {

                    insertable && (
                        <React.Fragment>
                            {
                                !isInserting
                                    ?
                                    (
                                        <div style={{ marginLeft: 10 }} className='d-flex align-items-center'>
                                            <i onClick={() => setIsInserting(true)} style={{ fontSize: 22 }} className='actionIcon text-success fa fa-plus-circle' />
                                        </div>
                                    )
                                    :
                                    (
                                        <React.Fragment>
                                            <div style={{ marginLeft: 10 }} className='d-flex align-items-center'>
                                                <i onClick={submitHandler} style={{ fontSize: 22 }} className='actionIcon text-success fa fa-check-circle' />
                                            </div>
                                            <div style={{ marginLeft: 10 }} className='d-flex align-items-center'>
                                                <i onClick={() => { setIsInserting(false); setInsertValue(''); }} style={{ fontSize: 22 }} className='actionIcon text-danger fa fa-times-circle' />
                                            </div>
                                        </React.Fragment>
                                    )

                            }
                        </React.Fragment>
                    )
                }
            </div>
        </React.Fragment>
    )
}

CustomMultiSelect.defaultProps = {
    insertable: undefined,
    disabled: false,
    additionalValue1Name: undefined,
    innerPropName: undefined,
    labelText: undefined,
    isLabelRequired: false
}

export default CustomMultiSelect;